import { PreservationOfRecordType } from "src/models/PreservationOfRecord";
import {
  DocumentRequestType,
  EditOrDetailType,
} from "src/models/ReadersManagementModel";
import { ProvideDataType } from "src/pages/screen/ReadersManagement/ProvideData/constants";

const routePaths = {
  Auth: {
    Index: "/auth",
    Login: "/auth/login",
    ForgotPassword: "/auth/forgot-password",
    NewPassword: "/auth/new-password",
    ChangeSuccesPassword: "/auth/Succes-password",
  },
  Screen: {
    Index: "/digitize",
    Directory: {
      Index: "/digitize/directory",
      Directory: {},
      Warehose: {
        Index: "/digitize/warehose",
      },
    },
    Readers: {
      Index: "/digitize/readers",
      RegistrationList: {
        Index: "/digitize/readers/registration-list",
        Add: "/digitize/readers/registration-list/add",
        Edit: "/digitize/readers/registration-list/:id",
      },
      RequestInformation: {
        Index: "/digitize/readers/request-information",
        Add:
          "/digitize/readers/request-information/add/:type(" +
          Object.values(DocumentRequestType).join("|") +
          ")",
        Edit:
          "/digitize/readers/request-information/:type(" +
          Object.values(DocumentRequestType).join("|") +
          ")/:view(" +
          Object.values(EditOrDetailType).join("|") +
          ")?=:id",
      },
      ProvideData: {
        Index: "/digitize/readers/provide-data",
        Create:
          "/digitize/readers/provide-data/create/:type(" +
          Object.values(ProvideDataType).join("|") +
          ")",
        Detail:
          "/digitize/readers/provide-data/:type(" +
          Object.values(ProvideDataType).join("|") +
          ")/:id/:action(view|edit)",
      },
    },
    Report: {
      Index: "/digitize/report",
      StorageStatus: {
        Index: "/digitize/report/report-status",
      },
      StorageWork: {
        Index: "/digitize/report/report-work",
      },
    },
    Administration: {
      Index: "/digitize/administration",
      User: {
        Index: "/digitize/administration/user",
        Add: "/digitize/administration/user/add",
        Edit: "/digitize/administration/user/edit",
      },
      OrganizationUnits: {
        Index: "/digitize/administration/organizationUnits",
      },
      Role: {
        Index: "/digitize/administration/role",
      },
    },
    Search: {
      Index: "/digitize/advancedSearch",
      Profile: {
        Index: "/digitize/advancedSearch/Profile",
        DetailsProfile:
          "/digitize/advancedSearch/Profile/DetailsProfile/:id/:action(view|edit)",
      },
      Text: {
        Index: "/digitize/advancedSearch/Document",
        DetailsDocument:
          "/digitize/advancedSearch/Document/DetailsDocument/:id/document/:documentId",
      },
      Fonts: {
        Index: "/digitize/advancedSearch/Fonts",
        DetailsFonts: "/digitize/advancedSearch/Fonts/DetailsFonts",
      },
      Reader: {
        Index: "/digitize/advancedSearch/Reader",
        RegistrationDetails: {
          Index: "/digitize/advancedSearch/Reader/RegistrationDetails/:id",
        },
        RequestDatails: {
          Index:
            "/digitize/advancedSearch/Reader/RequestDatails/:type(" +
            Object.values(DocumentRequestType).join("|") +
            ")/:view(" +
            Object.values(EditOrDetailType).join("|") +
            ")?=:id",
        },
        ProvideDetails: {
          Index:
            "/digitize/advancedSearch/Reader/ProvideDetails/:type(" +
            Object.values(ProvideDataType).join("|") +
            ")/:id/:action(view|edit)",
        },
      },
    },
    Categories: {
      Index: "/digitize/categories",
      Warehouse: "/digitize/categories/warehouse",
    },
    User: {
      Index: "/digitize/user",
      Staff: {
        Index: "/digitize/user/staff",
        Add: "/digitize/user/staff/add",
        Edit: "/digitize/user/staff/:id/edit",
      },
      Agency: {
        Index: "/digitize/user/agency",
        Add: "/digitize/user/agency/add",
        Edit: "/digitize/user/agency/edit",
      },
    },
    Phongs: {
      Index: "/digitize/phongs",
      Add: "/digitize/phongs/add",
      Edit: "/digitize/phongs/edit",
      Details: "/digitize/phongs/details",
    },

    Product: {
      Index: "/digitize/product",
      Category: {
        Index: "/digitize/product/category",
      },
      Attribute: {
        Index: "/digitize/product/attribute",
      },
      Review: {
        Index: "/digitize/product/review",
      },
      Tag: {
        Index: "/digitize/product/tag",
      },
    },

    PreservationOfRecord: {
      Index: "/digitize/preservation-of-record",
      Family: {
        Index: "/digitize/preservation-of-record/family",
        Create:
          "/digitize/preservation-of-record/family/create/:type(" +
          Object.values(PreservationOfRecordType).join("|") +
          ")",
        Detail:
          "/digitize/preservation-of-record/family/:id/:action(view|edit)",

        CirculationDocument: {
          Index: "/digitize/preservation-of-record/family/circulation-document",
          Create:
            "/digitize/preservation-of-record/family/circulation-document/create",
          View:
            "/digitize/preservation-of-record/family/circulation-document/:id",
        },
      },
      Organization: {
        Index: "/digitize/preservation-of-record/organization",
        Create:
          "/digitize/preservation-of-record/organization/create/:type(" +
          Object.values(PreservationOfRecordType).join("|") +
          ")",
        Detail:
          "/digitize/preservation-of-record/organization/:id/:action(view|edit)",

        CirculationDocument: {
          Index:
            "/digitize/preservation-of-record/organization/circulation-document",
          Create:
            "/digitize/preservation-of-record/organization/circulation-document/create",
          View:
            "/digitize/preservation-of-record/organization/circulation-document/:id",
        },
      },
      DocumentDetail:
        "/digitize/preservation-of-record/:id/document/:documentId",
    },
  },

  Agency: {
    Index: "/agency",
  },
};

export default routePaths;
